// extracted by mini-css-extract-plugin
module.exports = {"overview":"styles_overview__1wJo_"};